const isHighSurrogate = (code: number) => code >= 0xd800 && code <= 0xdbff;

// The server writes a lone surrogate as U+FFFD, so text containing one never hydrates (React #425).
export const removeLoneSurrogates = (text: string) =>
	text.replace(
		/([\uD800-\uDBFF][\uDC00-\uDFFF])|[\uD800-\uDFFF]/g,
		(_match, pair: string | undefined) => pair ?? '',
	);

// Shortens a truncation limit by one when it would split a surrogate pair (e.g. an emoji).
export const surrogateSafeLimit = (text: string, limit: number) =>
	limit > 0 && isHighSurrogate(text.charCodeAt(limit - 1)) ? limit - 1 : limit;
